export const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#f8f8ff",
    border: "1px solid #656eb2",
    boxShadow: "0px 17px 24px -14px rgb(121 137 255 / 55%)",
    borderRadius: "12px",
    height: "80px",
    backgroundSize: "20px 15px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const dropdownSelectStyle = {
  control: (base) => ({
    ...base,
    backgroundColor: "white",
    border: "2px solid #E8EDF8",
    boxShadow: "none",
    borderRadius: "9px",
    height: "clamp(35px, 5vw, 50px)",
    minWidth: "180px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
};

export const customCongressStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#f8f8ff",
    border: "1px solid #656eb2",
    boxShadow: "0px 17px 24px -14px rgb(121 137 255 / 55%)",
    borderRadius: "12px",
    height: "50px",
    backgroundSize: "20px 15px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const regionSelectStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
    border: "0.5px solid #5A69DA",
    borderRadius: "3px",
    padding: "0",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
};

export const statusSelectStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    display: state.isFocused ? "block" : "none",
    color: "white",
  }),
  valueContainer: (base) => ({
    ...base,
    textAlign: "center",
  }),
};

export const attendanceStatusSelectStyles = {
  control: (base) => ({
    ...base,
    width: "100%",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
  valueContainer: (base) => ({
    ...base,
    textAlign: "center",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999, // Ensures dropdown appears in front of everything
  }),
};

export const searchInputStyles = {
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
};

export const batchStatusStyle = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "white" : "white",
    backgroundColor: state.isClicked ? "#2534A3" : "initial",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  control: (base) => ({
    ...base,
    backgroundColor: "#4252C9",
    borderRadius: "3px",
    borderColor: "#4252C9",
    borderStyle: "none",
  }),
  singleValue: (base) => ({
    ...base,
    color: "white",
  }),
  placeholder: (base) => ({
    ...base,
    color: "white",
    textTransform: "uppercase",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 2,
  }),
};

export const statusFilterStyle = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? "white" : "white",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    color: "white",
  }),
  control: (base) => ({
    ...base,
    borderRadius: "3px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "white",
  }),
  placeholder: (base) => ({
    ...base,
    textTransform: "uppercase",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 2,
  }),
  multiValue: (provided) => {
    return {
      ...provided,
      backgroundColor: "white",
      borderColor: "#00316d",
      borderRadius: "6px",
      borderStyle: "solid",
      borderWidth: "2px",
      padding: "2px 5px",
      display: "flex",
      alignItems: "center",
    };
  },
  multiValueLabel: (provided) => ({
    ...provided,
    color: "black",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "black",
    ":hover": {
      backgroundColor: "#ffffff",
      color: "#ff0000",
    },
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "white",
      color: state.isSelected ? "#00316d" : provided.color,
      fontWeight: "600",
    };
  },
};

export const customProjectStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#f8f8ff",
    border: "1px solid #656eb2",
    boxShadow: "0px 17px 24px -14px rgb(121 137 255 / 55%)",
    borderRadius: "12px",
    height: "80px",
    backgroundSize: "20px 15px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const addProjectDropdownStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    border: state.isFocused ? "2px solid #007AFF" : "2px solid #D8DCE3",
    borderRadius: "13px",
    height: "clamp(35px, 5vw, 50px)",
    overflow: "auto",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const addProjectSearchInputStyle = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    border: state.isFocused ? "2px solid #007AFF" : "2px solid #E5E5E5",
    borderRadius: "13px",
    height: "50px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: "none",
  }),
};

export const accountCustomStyle = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F5F5F7",
    borderRadius: "16px",
    height: "60px",
    overflow: "auto",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const filterAccountStyle = {
  control: (base) => ({
    ...base,
    border: "0.5px solid #5A69DA",
    borderRadius: "3px",
    padding: "0",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const MultiSelectorStyle = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F5F5F7",
    borderRadius: "16px",
    height: "60px",
    overflow: "auto",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const NewsMultiSelectorStyle = {
  control: (base) => ({
    ...base,
    backgroundColor: "#F5F5F7",
    borderRadius: "16px",
    maxHeight: "200px",
    minHeight: "60px",
    overflow: "auto",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const NewsCustomFormStyle = {
  control: (base) => ({
    ...base,
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    borderRadius: "none",
    boxShadow: "none",
    overflow: "auto",
    height: "50px",
    background: "transparent",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    display: "none",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

export const modalDropdownStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "transparent",
    border: state.isFocused ? "2px solid #007AFF" : "2px solid #E5E5E5",
    borderRadius: "13px",
    height: "45px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "5px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
    top: "unset",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};
